export const ScrollUp = () => {
    return (
        <svg fill="none" viewBox="0 0 168 33" xmlns="http://www.w3.org/2000/svg" role="presentation" aria-hidden="true">
                        <path d="m85.076 0 29.51 31.819c-0.543 0.9544-1.636 0.8621-2.057 0.508-5.07-4.2282-11.458-12.279-16.174-17.174-1.488-1.5445-11.16-12.802-12.028-12.587-3.1352 3.7664-28.586 30.721-30.793 30.274l-0.5337-1.5496 15.676-14.604 15.373-16.687h1.0262z" fill="currentColor"></path>
                    </svg>
    );
};